import Cookies from 'js-cookie';

/**
 * This sets session or removes session cookies for targeting DY experiences
 * via two url parameters: blCookieSet or blCookieRemove.
 *
 * The cookies themselves must begin with '_bl_dev__' which is the established
 * prefix for our temporary dev cookies, vs production cookies that should begin with
 * '_bl_prod__'.
 *
 * To set or remove multiple cookies, include the same parameter more than once, eg:
 * http://127.0.0.1:3000/?blCookieSet=_bl_dev__foo&blCookieSet=_bl_bar__
 *
 * The remove method isn't totally necessary as these are session cookies and will
 * be removed when the session ends, just a convenience.
 */

export const urlCookies = {
  init() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('blCookieSet') || urlParams.has('blCookieRemove')) {
      const setArray = urlParams.getAll('blCookieSet') || [];
      const removeArray = urlParams.getAll('blCookieRemove') || [];
      for (const cookieName of setArray) {
        if (cookieName.startsWith('_bl_dev__')) {
          Cookies.set(cookieName, true);
        }
      }
      for (const cookieName of removeArray) {
        if (cookieName.startsWith('_bl_dev__')) {
          Cookies.remove(cookieName);
        }
      }
    }
  },
};
